(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.knepper-yt-play');
    if(!btn) return;
    var wrap = btn.closest('.knepper-yt');
    if(!wrap) return;
    var id = wrap.getAttribute('data-yt');
    if(!id || !/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    try{ if(window.uc && typeof window.uc.deactivateBlocking === 'function'){ window.uc.deactivateBlocking(['BJz7qNsdj-7']); } }catch(err){}
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1';
    f.title = wrap.getAttribute('data-yt-title') || 'YouTube Video';
    f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen','');
    wrap.innerHTML = '';
    wrap.appendChild(f);
  });
})();
